import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router";

const Coverletter = () => {
  const push = useNavigate();
  return (
    <div className="coverletter">
      <h3>Why Hire Me?!</h3>
      <p>
        Dear reader, if you've ended up on this page, it can only mean one of
        two things: either you are still considering giving me a chance, or you
        are simply viewing my portfolio. If it's the latter case, I'm not sure
        why you're still here… However, if you are looking to hire someone,
        buckle up and get ready to be convinced that I am the best option.
      </p>
      <p>
        Just in recent past, the idea of becoming a software engineer wasn't
        even on my radar. I was a junior specializing in social sciences,
        honestly disliking my degree. However, my life took a significant turn
        when I began exploring software engineering. In a mere six months, I
        went from not knowing what HTML was to actively working on full-stack
        projects. Reason one to hire me: I'm a highly focused and exceptionally
        fast learner.
      </p>

      <p>
        To bolster the effectiveness of my argument, I have learned three
        foreign languages by myself. I can speak and write in all of them very
        fluently. One of them is English, which I believe I speak at the same
        level as my native tongue. I am currently on a journey to learn a fourth
        language, and I am at a B1 level. To sum it up, reason number two to
        hire me is that one of the most important skills a developer can have is
        self-education and the ability to keep up with new technologies as they
        advance at the speed of light. I believe I possess this skill.
      </p>

      <p>
        Lastly, while I may not have experience in this particular field, I have
        worked in sales for over two years and became a sales team leader in
        just one year. So, I already know how to work effectively in a team and
        have some leadership skills for the future.
      </p>

      <p>
        In conclusion, I am ready to do whatever it takes to achieve my goals
        and become successful in this field. With a little help from the
        internet, there is nothing I can't build or learn. My determination,
        fast learning abilities, multilingual skills, and prior leadership
        experience make me a compelling candidate for any software engineering
        position, and I am excited to bring my unique perspective and skills to
        your team.
      </p>

      <button onClick={() => push(-1)}>
        <ArrowBackIcon />
      </button>
    </div>
  );
};

export default Coverletter;
